"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageScrollRegistrarSymbol = void 0;
exports.PageScrollRegistrarSymbol = Symbol.for('PageScrollRegistrar');
//# sourceMappingURL=pageScrollRegistrar.js.map